import styled from "styled-components";
import { Link as DefaultLink } from "../../link/link";

export const Container = styled.div`
  width: 100%;

  .carousel .slide img {
    max-height: 526px;
    width: auto !important;
  }

  .carousel .control-dots {
    margin: 32px 0px;

    .dot {
      border-radius: 50px;
      height: 8px;
      width: 38px;
    }
  }

  @media (max-width: 768px) {
    display: flex;

    .carousel-root {
      width: 100%;
    }
  }
`;

export const BannerContainer = styled.div`
  background-color: #f0f3ea;
  padding: 82px 179px 72px 179px;

  @media (max-width: 768px) {
    padding: 160px 32px 32px 32px;
  }
`;

export const BannerWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 28px;
    padding: 0;
    margin-bottom: 32px;
  }
`;

export const BannerContent = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: 54px 0px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 0;
    width: 100%;
  }
`;

export const Title = styled.h4`
  color: #00a687;
  margin-bottom: 16px;
  text-align: center;
  width: 100%;

  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 27.58px;
  }
`;

export const Description = styled.p`
  color: #1d1d1d;
  font-size: 24px;
  line-height: 27.58px;
  margin-bottom: 62px;
  text-align: center;
  width: 100%;

  strong {
    font-weight: bold;
  }

  em,
  i {
    font-style: italic;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 0;
  }
`;

export const Link = styled(DefaultLink)`
  background-color: #da6529;
  font-size: 24px;
  font-weight: 700;
  line-height: 27.58px;
  padding: 16px 62px;
  width: auto;
`;

export const DesktopLink = styled(Link)`
  margin-top: 62px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileLink = styled(Link)`
  @media (min-width: 767px) {
    display: none;
  }
`;

export const Divs = styled.div`
  display: grid;
  gap: 62px;
  grid-template-columns: 1fr 1fr;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background-color: #f6f6f6;
  border-radius: 8px;
  box-shadow: 0 5px 20px #00a98851;
  padding: 24px;
`;

export const CardTitle = styled.h4`
  color: #00a687;
  font-size: 24px;
  line-height: 28px;
  margin-bottom: 16px;
`;

export const List = styled.ul`
  list-style: none;
  margin-bottom: 16px;
`;

export const ListItem = styled.li`
  margin-bottom: 8px;
`;

export const Arrow = styled.img`
  display: inline;
  margin-right: 4px;
  margin-bottom: -3px;
`;
